<app-pias-layout>
    <div pias-layout-content>
        <br>
        <div class="header-section">
            <h4 class="mat-h1">Templates</h4>
            <div class="header-actions">
                <button mat-flat-button color="primary" (click)="newTemplate()">
                    <mat-icon>add</mat-icon> Create Template
                </button>
            </div>
        </div>

        <div class="template-wrapper">
            <div class="mat-elevation-z2 table-container">
                <table mat-table [dataSource]="dataSource">

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Template Name </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="main-name">{{ element.name }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="channel">
                        <th mat-header-cell *matHeaderCellDef> Channel </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="channel-icon">
                                @if (element.channel === 'email') {
                                <mat-icon>email</mat-icon>
                                } @else {
                                <mat-icon>chat</mat-icon>
                                }
                                {{ element.channel }}
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="startDate">
                        <th mat-header-cell *matHeaderCellDef> Start Date </th>
                        <td mat-cell *matCellDef="let element"> {{ element.startDate | date:'dd/MM/yyyy' }} </td>
                    </ng-container>

                    <ng-container matColumnDef="endDate">
                        <th mat-header-cell *matHeaderCellDef> End Date </th>
                        <td mat-cell *matCellDef="let element"> {{ element.endDate | date:'dd/MM/yyyy' }} </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef> Status </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="custom-badge" [ngClass]="element.status.toLowerCase()">
                                {{ element.status || '-' }}
                            </span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef> Actions </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button type="button" aria-label="View template" (click)="onView(element)">
                                <mat-icon>visibility</mat-icon>
                            </button>
                            <button mat-icon-button type="button" aria-label="Edit template" (click)="onEdit(element)">
                                <mat-icon>edit</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
                            <mat-icon>mail</mat-icon>
                            <span>No templates yet. Use "Create Template" to add one.</span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</app-pias-layout>